import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as mojoDetailsWidgetReducers from "./mojo-details-widget.reducers";

export const selectDetailsState = createFeatureSelector<mojoDetailsWidgetReducers.State>('Details');

export const {
  selectEntities: selectDetailsEntities
} = mojoDetailsWidgetReducers.adapter.getSelectors(selectDetailsState);

export const selectEntityById = (id: string) =>
  createSelector(selectDetailsEntities, (entities) => entities[id]);

export const selectDetails = (id: string) =>
  createSelector(selectEntityById(id),
    (entity: mojoDetailsWidgetReducers.MojoDetailsWidgetInstance) => {
      return entity ? entity.details : null;
    });
